import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { Provider } from "react-redux";
import { baseName } from "./settings";
import { store } from "./store";

export const pollKey = "POLL_DATE";
const APP_VERSION = process.env.REACT_APP_CURRENT_GIT_SHA;

if (sessionStorage.getItem("APP_VERSION") !== APP_VERSION) {
  const pollNumber = localStorage.getItem(pollKey);
  sessionStorage.clear();
  localStorage.clear();
  if (pollNumber) {
    localStorage.setItem(pollKey, pollNumber);
  }
  sessionStorage.setItem("APP_VERSION", APP_VERSION || ``);
}


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

root.render(
  // <React.StrictMode>
  <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
    <GoogleOAuthProvider clientId={googleClientId}>
      <Router basename={baseName}>
        <Provider store={store}>
          <App />
        </Provider>
      </Router>
    </GoogleOAuthProvider>
  </GoogleReCaptchaProvider>
  /* </React.StrictMode> */
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
